export default __webpack_public_path__ + "static/media/enter.10d0b51f.svg";